import Actionbar from "src/components/common/actionbar/Authactionbar";
import { Message } from "src/components/common/form/Message";
import { usePRD3030_R01Store } from "src/containers/mes/PRD/PRD3030_R01/Store_PRD3030_R01";
import useUiuxStore from "src/store/useUiuxStore";
import { Content_PRD3030_R01 } from "./Content_PRD3030_R01";
import { SearchSection_PRD3030_R01 } from "./SearchSection_PRD3030_R01";
import { Table_PRD3030_R01 } from "./Table_PRD3030_R01";
import { LotTable_PRD3030_R01 } from "./LotTable_PRD3030_R01";
import { useRef } from "react";
import { AgGridReact } from "ag-grid-react";
import { PRD3030_R01GridRowData } from "./Dto_PRD3030_R01";
import { useMouseContent } from "src/utils/mouse/mouseContent";

/**
 * 생산 실적 관리 컨테이너 컴포넌트
 * 생산 실적 관리 화면의 전체 레이아웃과 상태 관리를 담당
 */
export const Container_PRD3030_R01 = () => {
    const { initData } = usePRD3030_R01Store();
    const { setMessage } = useUiuxStore();
    const gridRef = useRef<AgGridReact<PRD3030_R01GridRowData>>(null);

    // 리사이저 설정
    const RESIZER = {
        code: 'PRD3030_R01-main',
        type: 'width' as const,
        storageKey: 'PRD3030_R01-main-split-width',
        min: 20,
        max: 90,
        default: 60
    } as const;

    const containerRef = useRef<HTMLDivElement>(null);
    const lotTableRef = useRef<HTMLDivElement>(null);
    const isResizing = useRef(false);

    const { 
        splitValue,
        handleMouseDown,
        handleMouseUp
    } = useMouseContent({
        resizer: RESIZER,
        isResizing,
        containerRef,
        infoRef: lotTableRef
    });

    // Content에서 액션바 핸들러 함수들을 가져옴
    const {
        fetchData,
        handleExcelClick,
        fetchLotList,
    } = Content_PRD3030_R01({
        setMessage,
    });

    return (
        <div className="content-container">
            <Actionbar
                onFetchClick={fetchData}
                onSaveClick={undefined} // TODO: 저장 기능 구현 예정
                onDeleteClick={() => {}}
                onInitClick={initData}
                onExcelClick={handleExcelClick}
            />
            
            {/* 생산 실적 검색 섹션 */}
            <SearchSection_PRD3030_R01 />
            
            <div className="flex flex-1 p-[12px] gap-[4px] min-h-0" ref={containerRef}>
                {/* 생산 실적 테이블 */}
                <div className="h-full" style={{ width: `${splitValue}%` }}>
                    <Table_PRD3030_R01 gridRef={gridRef} onRowClick={fetchLotList} />
                </div>

                {/* 리사이저 */}
                <div
                    className="w-[6px] bg-gray-100 cursor-col-resize hover:bg-gray-300"
                    onMouseDown={(e: React.MouseEvent<HTMLDivElement>) => handleMouseDown('LR', e.nativeEvent)}
                    data-comment="리사이저"
                />
                
                {/* LOT 조회 테이블 */}
                <div className="h-full" style={{ width: `${100 - splitValue}%` }} ref={lotTableRef}>
                    <LotTable_PRD3030_R01 />
                </div>
            </div>
            
            {/* 메시지 표시 컴포넌트 */}
            <Message />
        </div>
    );
};
